/**
 * Central SEO configuration for TTelGo (customer brand) / TikTel Ltd. (company).
 * Used by runtime head updates and build-time prerender/sitemap scripts (mirrored in scripts/seo-shared.mjs).
 */

const rawSiteUrl = (import.meta.env.VITE_SITE_URL || 'https://www.ttelgo.com').replace(/\/$/, '')

export const SEO_CONFIG = {
  siteName: 'TTelGo',
  companyLegalName: 'TikTel Ltd.',
  siteUrl: rawSiteUrl,
  locale: 'en_US',
  defaultTitle: 'TTelGo Travel eSIM | Stay Connected Worldwide',
  defaultDescription:
    'Stay connected while traveling with TTelGo eSIM. Get fast, affordable prepaid mobile data across 200+ destinations with instant activation and no physical SIM required.',
  defaultOgDescription:
    'Stay connected while traveling with TTelGo eSIM. Get fast, affordable prepaid mobile data across 200+ destinations with instant activation.',
  defaultTwitterDescription:
    'Travel smarter with TTelGo eSIM. Get instant prepaid mobile data across 200+ destinations without changing your physical SIM.',
  // Linux production is case-sensitive; /images/ttelgo-og.jpg 404s.
  defaultOgImagePath: '/IMAGES/ttelgo-og.jpg',
  defaultOgImageAlt: 'TTelGo Travel eSIM - Stay Connected Anywhere',
  ogImageWidth: 1200,
  ogImageHeight: 630,
  logoPath: '/IMAGES/LogoUpdated.png',
  faviconPath: '/IMAGES/favicon-10.png',
  twitterSite: '@ttelgo',
  socialProfiles: [
    'https://www.facebook.com/ttelgo',
    'https://www.instagram.com/ttelgo/',
    'https://x.com/ttelgo',
    'https://uk.linkedin.com/company/ttelgoo',
    'https://www.youtube.com/@ttelgo',
    'https://www.tiktok.com/@ttelgo',
  ],
  appStoreUrl: 'https://apps.apple.com/app/id6777471257',
  playStoreUrl:
    'https://play.google.com/store/apps/details?id=com.ttelgo.mobileapp.publicapp&pcampaignid=web_share',
} as const

export const DEFAULT_OG_IMAGE = `${SEO_CONFIG.siteUrl}${SEO_CONFIG.defaultOgImagePath}`
export const DEFAULT_LOGO_URL = `${SEO_CONFIG.siteUrl}${SEO_CONFIG.logoPath}`

export const NOINDEX_PATH_PREFIXES = [
  '/admin',
  '/checkout',
  '/profile',
  '/my-esim',
  '/forgot-password',
  '/reset-password',
] as const

export const REGION_SEO_SLUGS = [
  'Europe',
  'Asia',
  'Americas',
  'Middle East',
  'Africa',
  'Oceania',
] as const
